import { Translate } from 'react-redux-i18n'
import { keyBy } from '../helpers/common'
import { FORMAT, formatDateTime } from '../helpers/datetime'
import { formatText } from '../helpers/value'
import { USER_TYPE } from '../utils/authorization'
import { EMPTY_VALUE } from '../utils/common'
import { UNIT, UNIT as UNIT_TYPE } from '../utils/currency'
import { DELIVERY_TIME, IDS_REPORT, LANGUAGE, VERSION_REPORT } from './constant'
import { TYPE_DATA_REPORT_STORE, TYPE_REPORT_STORE } from './store/slice'

export const ID_BLOCK_FS = 3
export const ID_BLOCK_SCORE = 4

export const covertObjBooleanToArr = (obj) =>
  Object.keys(obj).filter((item) => obj[item])

export const getTotalPrice = (data, key) =>
  data
    .map((item) => item[key])
    .reduce((accumulator, currentValue) => accumulator + currentValue, 0)

export const getDataBusinessReport = (data, ids) => {
  const objIds = {}

  const dataType = data.filter((item) =>
    ids.includes(item.fiinGateReportTypeId),
  )
  const idsReport = dataType.map((key) => key.id)

  idsReport.forEach((item) => {
    objIds[item] = true
  })

  const listReport = dataType.map((item) => ({
    id: item?.id,
    reportType: item?.fiinGateReportTypeName,
    version: item?.readyVersion,
    dateCreated: item?.readyVersionCreateDate,
    idTypeReport: item?.fiinGateReportTypeId,
    years: `${item?.availableData || ''}`.split(', ').map(Number),
    language: LANGUAGE.EN,
    currency: item?.currencyCode,
    additionalCurrency: item?.additionalCurrencyCode,
    unit: UNIT.SINGLE.unitKey,
    price: item?.price,
    subPrice: item?.discountedPrice,
    companyName: item?.organizationName,
    discountId: item?.discountId,
    discountPercentage: item?.discountPercentage,
    fiinGateReportTypeId: item?.fiinGateReportTypeId,
    organizationId: item?.organizationId,
  }))

  const dataReport = keyBy(listReport, 'id')

  return {
    ids: objIds,
    dataBusiness: dataReport,
  }
}

export const handleFsFactSheet = (data) => {
  const objAudit = {}
  const objMethod = {}
  const key = data?.dataAvailabilities
    ? keyBy(data?.dataAvailabilities, 'year')
    : {}
  Object.keys(key).forEach((item) => {
    objAudit[item] = key[item]?.audited
    objMethod[item] = key[item]?.isDirect
  })
  return {
    consolidated: data?.consolidated,
    auditStatuses: objAudit,
    methods: objMethod,
    yearsFS: data?.dataAvailabilities
      ? Object.values(data?.dataAvailabilities).map((item) => item?.year)
      : [],
  }
}

export const getDataFactSheetReport = (data, ids, userId) => {
  const objIds = {}

  const dataType = data.filter((item) =>
    ids.includes(item.fiinGateReportTypeId),
  )
  const idsReport = dataType.map((key) => key.id)

  idsReport.forEach((item) => {
    objIds[item] = true
  })

  const listReport = dataType.map((item) => {
    const dataBlock = item?.dataBlocks
    const dataBlockFS = dataBlock.find(
      (key) => key?.dataBlockId === ID_BLOCK_FS,
    )

    return {
      id: item?.id,
      isOnlyFinancialStatement: [
        USER_TYPE.PREMIUM,
        USER_TYPE.STANDARD,
        USER_TYPE.TRIAL,
      ].includes(userId),
      dataBlocks: dataBlock.map((key) => ({
        ...key,
        name: key?.dataBlockName,
        id: key?.dataBlockId,
      })),
      sourceOrganizationId: dataBlockFS?.reportSourceName,
      sourceId: dataBlockFS?.reportSourceId,
      years: `${item?.availableData || ''}`.split(', ').map(Number),
      ...handleFsFactSheet(dataBlockFS),
      language: item?.languageCode,
      currency: item?.currencyCode,
      unit: item?.currencyUnit,
      additionalCurrency: item?.additionalCurrencyCode,
      additionalUnit: item?.additionalCurrencyUnit,
      price: item?.price,
      subPrice: item?.discountedPrice,
      companyName: formatText(item?.organizationName),
      discountId: item?.discountId,
      discountPercentage: item?.discountPercentage,
      fiinGateReportTypeId: item?.fiinGateReportTypeId,
      organizationId: item?.organizationId,
    }
  })

  const dataReport = keyBy(listReport, 'id')

  return {
    idsFactSheet: objIds,
    dataFacsheet: dataReport,
  }
}

export const handleCartItems = (data, userId) => {
  const { dataBusiness, ids } = getDataBusinessReport(data, [
    IDS_REPORT.CREDIT_BUSINESS,
    IDS_REPORT.COMPREHENSIVE_BUSINESS,
    IDS_REPORT.STANDARD_BUSINESS,
  ])

  const { dataFacsheet, idsFactSheet } = getDataFactSheetReport(
    data,
    [IDS_REPORT.FIINGATE_FACTSHEET],
    userId,
  )

  return {
    [TYPE_REPORT_STORE.FIINGATE_FACTSHEET]: {
      [TYPE_DATA_REPORT_STORE.IDS]: idsFactSheet,
      [TYPE_DATA_REPORT_STORE.BY_ID]: dataFacsheet,
    },
    [TYPE_REPORT_STORE.BUSINESS_CREDIT]: {
      [TYPE_DATA_REPORT_STORE.IDS]: ids,
      [TYPE_DATA_REPORT_STORE.BY_ID]: dataBusiness,
    },
  }
}

export const handleVersionReport = (
  version,
  dateCreated,
  idTypeReport,
  locale,
) => {
  if (version) {
    return (
      <>
        <Translate value={VERSION_REPORT.READY} />
        &nbsp;(
        <Translate value="cartAndOrders.main.dateCreated" />
        :&nbsp;{formatDateTime(dateCreated, FORMAT.DATE, locale)})
      </>
    )
  }
  return (
    <>
      <Translate value={VERSION_REPORT.REQUEST} />
      &nbsp;(
      <Translate value="cartAndOrders.main.deliveryTime" />
      :&nbsp;
      <Translate value={DELIVERY_TIME[idTypeReport]} />)
    </>
  )
}

export const handleUnitReport = (unit) => {
  return (
    unit && (
      <Translate
        value={
          Object.values(UNIT_TYPE).find((item) => item.multiplier === unit)
            ?.label
        }
      />
    )
  )
}

export const formatPrice = (price) => (price ? price : 0)

export const getPriceByCheck = (data, ids) => {
  const dataFilter = data.filter((item) => ids.includes(item.id))
  const totalPrice = getTotalPrice(dataFilter, 'price')
  const discountedPrice = getTotalPrice(dataFilter, 'discountedPrice')
  const discountValue = getTotalPrice(dataFilter, 'discountValue')

  const discountedPriceFactSheet = getTotalPrice(
    dataFilter.filter(
      (item) => item?.fiinGateReportTypeId === IDS_REPORT.FIINGATE_FACTSHEET,
    ),
    'discountedPrice',
  )
  const discountedPriceBusiness = getTotalPrice(
    dataFilter.filter(
      (item) => item?.fiinGateReportTypeId !== IDS_REPORT.FIINGATE_FACTSHEET,
    ),
    'discountedPrice',
  )

  return {
    totalPrice,
    discountedPrice,
    discountValue,
    discountedPriceFactSheet,
    discountedPriceBusiness,
  }
}

export const getDataChecked = (data) => {
  const { factSheet, businessCreditReport, check } = data
  const ids = covertObjBooleanToArr(check)
  const dataBusiness = Object.values(businessCreditReport.byId).filter((item) =>
    ids.includes(item?.id),
  )
  const dataFactSheet = Object.values(factSheet.byId).filter((item) =>
    ids.includes(item?.id),
  )
  return {
    dataBusiness,
    dataFactSheet,
  }
}

export const handleDataPlaceOrder = (data) => {
  const { dataBusiness, dataFactSheet } = getDataChecked(data)

  return [
    ...convertDataItemCart(dataBusiness),
    ...convertDataItemCart(dataFactSheet),
  ]
}

export const convertDataItemCart = (data) =>
  data.map((item) => ({
    cartItemId: item?.id,
    price: item?.price,
    discountId: formatPrice(item?.discountId),
    discountPercentage: formatPrice(item?.discountPercentage),
  }))

export const handleDataByTypeReport = (data) => {
  let objDataByIdReport = {
    [IDS_REPORT.CREDIT_BUSINESS]: [],
    [IDS_REPORT.COMPREHENSIVE_BUSINESS]: [],
    [IDS_REPORT.STANDARD_BUSINESS]: [],
    [IDS_REPORT.FIINGATE_FACTSHEET]: [],
    [IDS_REPORT.SCREENING]: [],
  }

  const { dataBusiness, dataFactSheet } = getDataChecked(data)

  dataBusiness.forEach((item) => {
    if (item?.fiinGateReportTypeId === IDS_REPORT.CREDIT_BUSINESS) {
      objDataByIdReport[IDS_REPORT.CREDIT_BUSINESS] = [
        ...objDataByIdReport[IDS_REPORT.CREDIT_BUSINESS],
        item,
      ]
    }
    if (item?.fiinGateReportTypeId === IDS_REPORT.COMPREHENSIVE_BUSINESS) {
      objDataByIdReport[IDS_REPORT.COMPREHENSIVE_BUSINESS] = [
        ...objDataByIdReport[IDS_REPORT.COMPREHENSIVE_BUSINESS],
        item,
      ]
    }
    if (item?.fiinGateReportTypeId === IDS_REPORT.STANDARD_BUSINESS) {
      objDataByIdReport[IDS_REPORT.STANDARD_BUSINESS] = [
        ...objDataByIdReport[IDS_REPORT.STANDARD_BUSINESS],
        item,
      ]
    }
  })
  dataFactSheet.forEach((item) => {
    objDataByIdReport[IDS_REPORT.FIINGATE_FACTSHEET] = [
      ...objDataByIdReport[IDS_REPORT.FIINGATE_FACTSHEET],
      item,
    ]
  })

  return objDataByIdReport
}

export const convertDataTablePackage = (dataPackage, dataByTypeReport) =>
  [
    {
      name: 'FiinGate Factsheet',
      currentBalance: dataPackage.find(
        (item) => item?.fiinGateReportTypeId === IDS_REPORT.FIINGATE_FACTSHEET,
      )?.quantity,

      orderedNumber: formatPrice(
        dataByTypeReport[IDS_REPORT.FIINGATE_FACTSHEET].length,
      ),
      id: IDS_REPORT.FIINGATE_FACTSHEET,
    },
    {
      name: 'Standard Business Report',
      currentBalance: dataPackage.find(
        (item) => item?.fiinGateReportTypeId === IDS_REPORT.STANDARD_BUSINESS,
      )?.quantity,
      orderedNumber: dataByTypeReport[IDS_REPORT.STANDARD_BUSINESS].length,
      id: IDS_REPORT.STANDARD_BUSINESS,
    },
    {
      name: 'Comprehensive Business Report',
      currentBalance: dataPackage.find(
        (item) =>
          item?.fiinGateReportTypeId === IDS_REPORT.COMPREHENSIVE_BUSINESS,
      )?.quantity,
      orderedNumber: formatPrice(
        dataByTypeReport[IDS_REPORT.COMPREHENSIVE_BUSINESS].length,
      ),
      id: IDS_REPORT.COMPREHENSIVE_BUSINESS,
    },
    {
      name: 'Credit Business Report',
      currentBalance: dataPackage.find(
        (item) => item?.fiinGateReportTypeId === IDS_REPORT.CREDIT_BUSINESS,
      )?.quantity,
      orderedNumber: formatPrice(
        dataByTypeReport[IDS_REPORT.CREDIT_BUSINESS].length,
      ),
      id: IDS_REPORT.CREDIT_BUSINESS,
    },
    {
      name: 'Screening',
      currentBalance: dataPackage.find(
        (item) => item?.fiinGateReportTypeId === IDS_REPORT.SCREENING,
      )?.quantity,
      orderedNumber: formatPrice(
        dataByTypeReport[IDS_REPORT.SCREENING]?.length,
      ),
      id: IDS_REPORT.SCREENING,
    },
  ].sort((a, b) => b.orderedNumber - a.orderedNumber)

export const checkPhoneValid = (value) => {
  if (!value) return false
  const phoneNumber = /^\+?[0-9]*$/gi
  return phoneNumber.test(value)
}

export const checkEmailValid = (value, disableRequired = false) => {
  if (!value) return disableRequired
  const email = /^[\w-.]+@([\w-]+\.)+[\w-]{2,4}$/gi
  return email.test(value)
}

export const getActiveItemUnit = (multiplier) =>
  multiplier
    ? Object.values(UNIT)
        .filter((item) => item.multiplier === multiplier)
        .map((key) => ({
          value: key.multiplier,
          label: key.label,
          isI18n: true,
        }))[0]
    : {}

export const convertAvailableFSData = (data) =>
  !!data?.years[0] ? data?.years.join(', ') : EMPTY_VALUE

export const handleListInteresting = (data) => {
  return data.map((item) => ({
    id: item?.organizationId,
    companyName: formatText(item?.organizationName),
    industry: item?.vsicName,
    size: item?.businessSizeRangeName,
    yearsOfOperation: item?.businessAgeName,
    creditRisk: item?.creditRiskScoreRangeName,
    performance: item?.performanceScoreRangeName,
    purchasedReport: item?.purchasedReport,
    addedPortfolio: item?.addedPortfolio,
    views: item?.views,
  }))
}

export const handelDataGetDataAvailability = (data, key) =>
  Object.keys(data).map((item) => ({
    year: Number(item),
    [key]: data[item],
  }))

export const NUMBER_FULL_DATA_BLOCK = 5

export const checkFullDataBlock = (data, ids, isHasFull = false) => {
  return ids.some((id) =>
    isHasFull
      ? data[id].dataBlocks.length >= NUMBER_FULL_DATA_BLOCK
      : data[id].dataBlocks.length < NUMBER_FULL_DATA_BLOCK,
  )
}

export const checkExistDataBlock = (data, ids) => {
  return ids.every((id) => !!data[id].dataBlocks.length)
}
